export default __webpack_public_path__ + "static/media/all_employees_icon.8010a0f3.svg";